import { Dialog as MuiDialog } from '@mui/material';
import { styled } from '@mui/material/styles';

const PREFIX = 'Dialog';

export const dialogClasses = {
  subtitle: `${PREFIX}-subtitle`,
  content: `${PREFIX}-content`,
  actionButtonLabel: `${PREFIX}-actionButtonLabel`,
  success: `${PREFIX}-success`,
  danger: `${PREFIX}-danger`,
  loadingText: `${PREFIX}-loadingText`,
};

export const StyledMuiDialog = styled(MuiDialog)(({ theme }) => ({
  [`& .${dialogClasses.subtitle}`]: {
    paddingTop: 0,
    marginTop: 0,
    fontSize: '0.8em',
    fontWeight: 'bold',
  },

  [`& .${dialogClasses.loadingText}`]: {
    padding: `${theme.spacing(3)} !important`,
    textAlign: 'center',
  },

  [`& .${dialogClasses.content}`]: {
    padding: `${theme.spacing(3)} !important`,
  },

  [`& .${dialogClasses.actionButtonLabel}`]: {
    fontSize: '0.8750em',
  },

  [`& .${dialogClasses.success}`]: {
    color: theme.palette.error.contrastText,
    backgroundColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },

  [`& .${dialogClasses.danger}`]: {
    color: theme.palette.error.contrastText,
    backgroundColor: theme.palette.error.light,
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
  },
}));
